import UserModel from '@/modules/users/UserModel';
import TableModel from '@/modules/tables/TableModel';
import GlobalSettingsModel from '@/modules/settings/global/GlobalSettingsModel';
import TicketSettingsModel from '@/modules/settings/ticket/TicketSettingsModel';
import SaleModel from '@/modules/reports/salesReport/SaleModel';
import RequestsTableModel from '@/modules/requests/requestsTables/RequestsTableModel';
import RequestModel from '@/modules/requests/requests/RequestModel';
import ProductModel from '@/modules/products/ProductModel';
import PrinterModel from '@/modules/printers/PrinterModel';
import OfferModel from '@/modules/offers/OfferModel';
import CommandModel from '@/modules/requests/commands/CommandModel';
import ClientModel from '@/modules/clients/ClientModel';
import CategoryModel from '@/modules/categories/CategoryModel';
import RoleModel from '@/modules/auth/RoleModel';
import ModuleModel from '@/modules/auth/ModuleModel';
import PermissionModel from '@/modules/auth/PermissionModel';
import BoxModel from '@/modules/reports/boxReport/BoxReportModel';
import {IModel} from '@/core/Types/IModel';
import ShiftModel from '@/modules/shifts/ShiftModel';
import BookingModel from '@/modules/bookings/BookingModel';
import AllergenModel from '@/modules/allergens/AllergenModel';
import BookingOptionAnswerModel from '@/modules/booking-options/booking-options-answers/BookingOptionAnswerModel';
import BookingOptionModel from '@/modules/booking-options/BookingOptionModel';
import KitchenTicketSettingsModel from '@/modules/settings/kitchen-ticket/KitchenTicketSettingsModel';
import IngredientModel from '@/modules/ingredients/IngredientModel';
import ProviderModel from '@/modules/providers/ProviderModel';
import PurchaseModel from '@/modules/purchases/PurchaseModel';
import PurchaseOrderModel from '@/modules/purchaseOrder/PurchaseOrderModel';
import ZoneModel from '@/modules/zones/ZoneModel';
import StockModel from '@/modules/stocks/StockModel';
import WarehouseModel from '@/modules/warehouses/WarehouseModel';
import TPVModel from '@/modules/auth/TPVModel';
import ScreenModel from '@/modules/screens/ScreenModel';
import StockProductModel from '@/modules/stocks/StockProductModel';
import AppSettingsModel from '@/modules/settings/app/AppSettingsModel';
import ProductReportModel from '@/modules/reports/productReport/ProductReportModel';
import StockReportModel from '@/modules/reports/stocksReport/StockReportModel';
import FamilyModel from '@/modules/families/FamilyModel';
import DomicilePickupSettingsModel from '@/modules/settings/domicile_pickup/DomicilePickupSettingsModel';
import DigitalMenuSettingsModel from '@/modules/settings/digital-menu/DigitalMenuSettingsModel';
import PredictionSaleModel from '@/modules/reports/salesReport/PredictionSaleModel';
import AprioriModel from '@/modules/reports/salesReport/AprioriModel';
import ProbabilityModel from '@/modules/reports/salesReport/ProbabilityModel';
import PredictionProductsModel from '@/modules/reports/salesReport/PredictionProductModel';
import EconomicSubscriptionModel from '@/modules/reports/economicSubscriptionsReport/EconomicSubscriptionModel';
import BookingSettingModel from '@/modules/settings/booking/BookingSettingModel';
import UnitModel from '@/modules/units/UnitModel';
import ModifierModel from '@/modules/modifiers/ModifierModel';
import OptionModel from '@/modules/modifier-options/OptionModel';
import StockSettingModel from '@/modules/settings/stock/StockSettingModel';
import AddressModel from '@/modules/addresses/AddressModel';
import ExpenseReportModel from '@/modules/reports/expensesReport/ExpenseReportModel';
import PaymentModel from '@/modules/requests/requestsTables/PaymentModel';
import InvoiceReportModel from '@/modules/reports/invoiceReport/InvoiceReportModel';
import ConsumptionsReportModel from '@/modules/reports/consumptionsReport/ConsumptionsReportModel';
import UserTimeTrackingModel from '@/modules/users/userTimeTracking/UserTimeTrackingModel';

export const Models: { [ModelName: string]: new() => IModel } = {
  User: UserModel,
  Module: ModuleModel,
  Box: BoxModel,
  Role: RoleModel,
  Table: TableModel,
  Allergen: AllergenModel,
  GlobalSetting: GlobalSettingsModel,
  AppSetting: AppSettingsModel,
  KitchenTicketSetting: KitchenTicketSettingsModel,
  TicketSetting: TicketSettingsModel,
  BookingSetting: BookingSettingModel,
  Sale: SaleModel,
  RequestTable: RequestsTableModel,
  Request: RequestModel,
  Permission: PermissionModel,
  Product: ProductModel,
  Printer: PrinterModel,
  Offer: OfferModel,
  Command: CommandModel,
  Client: ClientModel,
  Shift: ShiftModel,
  Booking: BookingModel,
  Option: BookingOptionModel,
  Answer: BookingOptionAnswerModel,
  Category: CategoryModel,
  Ingredient: IngredientModel,
  Provider: ProviderModel,
  Purchase: PurchaseModel,
  PurchaseOrder: PurchaseOrderModel,
  Stock: StockModel,
  StockProduct: StockProductModel,
  Screen: ScreenModel,
  Warehouse: WarehouseModel,
  Zone: ZoneModel,
  TPV: TPVModel,
  ProductReport: ProductReportModel,
  StockReport: StockReportModel,
  Family: FamilyModel,
  DomicilePickupSetting: DomicilePickupSettingsModel,
  DigitalMenu: DigitalMenuSettingsModel,
  PredictionsSale: PredictionSaleModel,
  PredictionProducts: PredictionProductsModel,
  AprioriReport: AprioriModel,
  ProbabilityReport: ProbabilityModel,
  EconomicSubscriptionReport: EconomicSubscriptionModel,
  ExpenseReport: ExpenseReportModel,
  Unit: UnitModel,
  Modifier: ModifierModel,
  ModifierOption: OptionModel,
  StockSetting: StockSettingModel,
  Address: AddressModel,
  Payment: PaymentModel,
  InvoiceReport: InvoiceReportModel,
  ConsumptionsReport: ConsumptionsReportModel,
  UserTimeTracking: UserTimeTrackingModel,
};




